

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_8gsnro91r8 = () => {
                    
                        if (document.querySelector('.beae-sgzc4lr6:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-sgzc4lr6:not([data-beae-bind])'),
                                
                                id: 'beae-sgzc4lr6',
                                isLive: true
                            });
                            document.querySelector('.beae-sgzc4lr6:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-8puosvu9:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-8puosvu9:not([data-beae-bind])'),
                                
                                id: 'beae-8puosvu9',
                                isLive: true
                            });
                            document.querySelector('.beae-8puosvu9:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-5bwvlora:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-5bwvlora:not([data-beae-bind])'),
                                
                                id: 'beae-5bwvlora',
                                isLive: true
                            });
                            document.querySelector('.beae-5bwvlora:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_8gsnro91r8()
                } else {
                    window.beaePageJS.push(jsHandle_8gsnro91r8)
                }
            